import { render, staticRenderFns } from "./socials.vue?vue&type=template&id=5bd3ccc2&scoped=true"
import script from "./socials.vue?vue&type=script&lang=js"
export * from "./socials.vue?vue&type=script&lang=js"
import style0 from "./socials.vue?vue&type=style&index=0&id=5bd3ccc2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bd3ccc2",
  null
  
)

export default component.exports